export const primary1Color = '#2196F3'
export const primary2Color = '#235585'



// WEBPACK FOOTER //
// ./src/utils/colors.js